const TOPICS = [
  { name: '高清电影', count: '2.8万' },
  { name: '热门韩剧', count: '1.2万' },
  { name: '国产剧集', count: '1.5万' },
  { name: '日本动漫', count: '9800' },
  { name: '动作冒险', count: '7600' },
  { name: '悬疑推理', count: '6200' },
  { name: '科幻大片', count: '5400' },
  { name: '爱情文艺', count: '8900' },
  { name: '综艺娱乐', count: '1.1万' },
  { name: '纪录片', count: '4300' },
  { name: '喜剧合集', count: '7100' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">热门话题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            探索热门影视话题，发现更多精彩内容
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              className="group flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 rounded-full bg-background-200/70 border border-background-300/30 hover:border-primary-500/40 hover:bg-background-200 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-200 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-[10px] text-foreground-600 bg-background-300/50 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}